import WebApiService from '../services/WebApiService';

export default class GoalsService extends WebApiService {

    constructor() {
        super();

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);
    }

    getGoalsList(pullData, clientAccountId, successCallback, errorCallback) {
        this.get('/api/Goals/GoalsList/' + pullData + "/" + clientAccountId, successCallback, errorCallback);
    }

    getGoal(pullData, goalId, successCallback, errorCallback) {
        this.get('/api/Goals/Goal/' + pullData + '/' + goalId, successCallback, errorCallback);
    }
}